import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=665cea57"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('665cea57')) {
      api.createRecord('665cea57', component.options)
    } else {
      api.reload('665cea57', component.options)
    }
    module.hot.accept("./Users.vue?vue&type=template&id=665cea57", function () {
      api.rerender('665cea57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Users/Users.vue"
export default component.exports